export default {
  id: 161,
  title: 'Target #161 - Converge',
  url: 'https://cssbattle.dev/play/161',
  colors: ['#E3516E', '#FADE8B'],
  solution:
    '<a a><a b><a c><style>[b],[c],body{background:#e3516e}a{position:fixed}[a]{top:58;left:108;width:184;height:184;background:#fade8b}[b],[c]{top:0;left:185;width:30;height:300}[b]{transform:rotate(45deg)}[c]{transform:rotate(-45deg)}</style>',
}
